import React from "react";
import { useLang } from "@/context/LanguageContext";

export const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <section className="relative py-10 border-y border-gold/15 bg-espresso/40 overflow-hidden" data-testid="marquee">
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {items.map((word, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8">
            <span className="font-editorial italic text-4xl sm:text-5xl text-outline">{word}</span>
            <span className="text-gold/60 text-2xl">✶</span>
          </span>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
